import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Stack, Typography, useTheme } from "@mui/material";
/**
 *
 * @param showAssignmentsCompleteIcon
 * @param showAssignmentsIncompleteIcon
 * @param sliderHeaderText
 * @returns
 */
export const SliderHeader = ({ hideText = false, showAssignmentsCompleteIcon = false, showAssignmentsIncompleteIcon = false, text, }) => {
    if (hideText) {
        return null;
    }
    const palette = useTheme().palette;
    return (_jsx(Box, Object.assign({ display: "flex", flexDirection: "column", alignItems: "flex-start" }, { children: _jsxs(Stack, Object.assign({ direction: "row", spacing: 1, alignItems: "center" }, { children: [_jsx(Typography, Object.assign({ variant: "h2", color: "primary" }, { children: text })), showAssignmentsCompleteIcon && _jsx(CheckCircleIcon, { style: { color: palette.success.main } }), showAssignmentsIncompleteIcon && _jsx(ErrorOutlineIcon, { style: { color: palette.primary.main } })] })) })));
};
